import { Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { styled } from '@mui/styles';
import { ErrorIcon } from '../../components/icons/error-icon';
import { SuccessIcon } from '../../components/icons/success-icon';
import { WarningIcon } from '../../components/icons/warning-icon';
import parse from 'html-react-parser';

const AVERAGE_READ_SPEED = 20;
const PREVENT_AUTO_HIDE = null;

const alertIcons = {
    success: <SuccessIcon />,
    error: <ErrorIcon />,
    info: <WarningIcon color="#5F8EFA" />,
    warning: <WarningIcon color="#E9A847" />,
};

export const SnackbarContainer = styled('div')(({ theme }) => ({
    '& .snackbar-container': {
        boxShadow: ' 0px 2px 7px rgba(112, 144, 176, 0.24)',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'center',
        '& .alert': {
            color: `${theme.palette.subline}`,
            fontSize: '14px',
            '& .MuiSvgIcon-root': {
                fontSize: '18px',
                justifySelf: 'center',
            },
            '& .MuiAlert-icon': {
                padding: 0,
                alignItems: 'center',
            },
        },
        '& .success': {
            background: theme.palette.colors.greenLight,
        },
        '& .error': {
            background: theme.palette.colors.redLight,
        },
        '& .info': {
            background: theme.palette.colors.blueLight,
        },
        '& .warning': {
            background: theme.palette.colors.orangeWhite,
        },
    },
}));

type Props = {
    onClose: () => any;
    severity: any;
    text: string;
    horizontal?: any;
    vertical?: any;
    open?: boolean;
};

export const Notification = ({ onClose, severity, text, horizontal, vertical, open = true }: Props) => {
    function setAutoHideDuration(textLength) {
        const minDuration = 6000;
        const textAverageReadTime = textLength * AVERAGE_READ_SPEED;

        if (textAverageReadTime < minDuration) {
            return minDuration;
        }

        if (textAverageReadTime > minDuration && textAverageReadTime < 5000) {
            return textAverageReadTime;
        }

        if (textAverageReadTime > 5000) {
            return PREVENT_AUTO_HIDE;
        }
    }

    return (
        <SnackbarContainer>
            <Snackbar
                className={`snackbar-container`}
                anchorOrigin={{ vertical: vertical || 'bottom', horizontal: horizontal || 'left' }}
                open={open}
                autoHideDuration={setAutoHideDuration(text.length)}
                onClose={onClose}
                sx={{
                    zIndex: 9999,
                }}
            >
                <MuiAlert
                    onClose={onClose}
                    severity={severity || 'success'}
                    className={`alert ${severity}`}
                    icon={alertIcons[severity]}
                >
                    {parse(text)}
                </MuiAlert>
            </Snackbar>
        </SnackbarContainer>
    );
};
